import { DotLegalDeleteDialog } from "@dotlegal/dotlegal-ui-components";
import { Trans } from "react-i18next";
import { useTranslation } from "@localization/useTranslation";
import { RiskScenarioRow } from "../RiskAssessmentsOverview.types";
import { useDeleteScenarioDialog } from "./DeleteScenarioDialog.hooks";

export interface IDeleteScenarioDialog {
    scenario: RiskScenarioRow;
    onClose: () => void;
    onDeleted: () => void;
}

export function DeleteScenarioDialog(props: IDeleteScenarioDialog) {
    const { translateString } = useTranslation();
    const { removeScenario, inProgress } = useDeleteScenarioDialog(props);

    return (
        <DotLegalDeleteDialog
            open
            headerText={translateString("deleteRiskAssessmentTitle")}
            alertBodyText={
                <Trans
                    i18nKey="deleteRiskAssessmentBody"
                    components={{
                        ul: <ul />,
                        li: <li />,
                    }}
                />
            }
            warningTranslation={translateString("warning")}
            deleteBtnText={translateString("delete")}
            cancelBtnText={translateString("cancel")}
            onDialogClose={props.onClose}
            onOkClick={removeScenario}
            inProgress={inProgress}
        />
    );
}
